import React, { useState, useEffect } from 'react';
import './BotSelector.css';

const BotSelector = ({ onBotSelect, selectedBot }) => {
  const [availableBots, setAvailableBots] = useState([]);
  const [loading, setLoading] = useState(true);

  // Configuration des bots disponibles
  const BOTS_CONFIG = {
    "solana_godmode": {
      name: "Solana DCA GODMODE",
      type: "DCA + Scalping",
      exchange: "Hyperliquid",
      asset: "SOL",
      color: "#9945FF",
      icon: "🚀"
    },
    "hyperliquid_rsi": {
      name: "Hyperliquid RSI Bot",
      type: "RSI Strategy", 
      exchange: "Hyperliquid",
      asset: "ETH",
      color: "#627EEA",
      icon: "📈"
    },
    "bitget_spot": {
      name: "Bitget Spot Trading",
      type: "Spot Trading",
      exchange: "Bitget", 
      asset: "BTC",
      color: "#F7931A",
      icon: "₿"
    }
  };

  useEffect(() => {
    fetchAvailableBots();
  }, []);

  const fetchAvailableBots = async () => {
    try {
      // Appel à l'API multi-bots
      const response = await fetch('http://213.156.132.188:8001/api/bots');
      const data = await response.json();
      
      if (data.success) {
        const botsWithConfig = data.data.bots.map(bot => ({
          ...bot,
          ...BOTS_CONFIG[bot.id],
          config: BOTS_CONFIG[bot.id]
        }));
        setAvailableBots(botsWithConfig);
      }
    } catch (error) {
      console.error('Erreur chargement bots:', error);
      // Mode fallback avec configuration statique
      const fallbackBots = Object.keys(BOTS_CONFIG).map(id => ({
        id,
        ...BOTS_CONFIG[id],
        connected: false,
        balance: 0,
        pnl: 0
      }));
      setAvailableBots(fallbackBots);
    } finally {
      setLoading(false);
    }
  };

  const handleBotSelect = (bot) => {
    onBotSelect(bot);
  };

  if (loading) {
    return (
      <div className="bot-selector loading">
        <div className="loading-spinner"></div>
        <span>Chargement des bots...</span>
      </div>
    );
  }

  return (
    <div className="bot-selector">
      <div className="bot-selector-header">
        <h3>🤖 Sélection du Bot</h3>
        <div className="bots-summary">
          {availableBots.filter(bot => bot.connected).length}/{availableBots.length} actifs
        </div>
      </div>
      
      <div className="bots-grid">
        {availableBots.map((bot) => (
          <div
            key={bot.id}
            className={`bot-card ${selectedBot?.id === bot.id ? 'selected' : ''} ${bot.connected ? 'connected' : 'disconnected'}`}
            onClick={() => handleBotSelect(bot)}
            style={{ '--bot-color': bot.color }}
          >
            <div className="bot-card-header">
              <div className="bot-icon">{bot.icon}</div>
              <div className="bot-status">
                <span className={`status-dot ${bot.connected ? 'connected' : 'disconnected'}`}></span>
              </div>
            </div>
            
            <div className="bot-info">
              <h4 className="bot-name">{bot.name}</h4>
              <div className="bot-details">
                <span className="bot-type">{bot.type}</span>
                <span className="bot-exchange">{bot.exchange}</span>
                <span className="bot-asset">{bot.asset}</span>
              </div>
            </div>
            
            {bot.connected && (
              <div className="bot-stats">
                <div className="stat">
                  <span className="stat-label">Balance</span>
                  <span className="stat-value">${bot.balance?.toFixed(2) || '0.00'}</span>
                </div>
                <div className="stat">
                  <span className="stat-label">PnL</span>
                  <span className={`stat-value ${bot.pnl >= 0 ? 'positive' : 'negative'}`}>
                    {bot.pnl >= 0 ? '+' : ''}${bot.pnl?.toFixed(2) || '0.00'}
                  </span>
                </div>
              </div>
            )}
            
            {!bot.connected && (
              <div className="bot-disconnected">
                <span>🔴 Déconnecté</span>
              </div>
            )}
          </div>
        ))}
      </div>
      
      <div className="bot-selector-footer">
        <button 
          className="refresh-bots-btn"
          onClick={fetchAvailableBots}
        >
          🔄 Actualiser
        </button>
        <button 
          className="view-all-btn"
          onClick={() => onBotSelect('all')}
        >
          📊 Vue d'ensemble
        </button>
      </div>
    </div>
  );
};

export default BotSelector;
